import React, {useState} from "react";
import {NewBlackoutDateProps} from "../../types/BlackoutPeriod";
import {Button} from "antd";
import {BigInput} from "./bigInput/BigInput";
import BigPicker from "./bigPicker/BigPicker";
import {daysOptions} from "../modals/blackoutPeriodModals/daysOptions";
import {timeOptions} from "../modals/blackoutPeriodModals/timeOptions";
import BigDatePicker from "./bigDatePicker/BigDatePicker";
import {DEFAULT_FORM_VALUES} from "../modals/blackoutPeriodModals/NewBlackoutPeriodModal";

interface NewBlackoutPeriodFormProps {
    onSubmit: (formValue: NewBlackoutDateProps) => void;
    onDelete: () => void;
    onClose: () => void;
    editedBlackoutPeriod?: NewBlackoutDateProps;
    selectedPeriodType: 1 | 2;
    setSelectedPeriodType: (newVal: 1 | 2) => void;
}

const NewBlackoutPeriodForm = ({ onSubmit, onDelete, onClose, editedBlackoutPeriod, selectedPeriodType, setSelectedPeriodType }: NewBlackoutPeriodFormProps) => {
    const [formValues, setFormValues] = useState<NewBlackoutDateProps>(editedBlackoutPeriod || DEFAULT_FORM_VALUES);
    const [formErrors, setFormErrors] = useState([]);

    const onFormUpdate = (newFormValues: NewBlackoutDateProps) => {
        !formErrors.length && setFormErrors([]);
        setFormValues(newFormValues);
    }

    return (
        <div className="new-blackout-period-creation">
            <BigInput
                value={formValues.title || ''}
                setValue={(newVal) => onFormUpdate({ ...formValues, title: newVal })}
                placeholder="Title"
                description="This title is not visible to your clients. It will help you understand the reason for this blackout period"
            />

            <div className="section">
                <div className="section-title">
                    What type of Blackout Period do you wish to schedule?
                </div>
                <div className="section-content">
                    <div className={`section-option ${selectedPeriodType === 1 ? 'selected' : ''}`} onClick={() => setSelectedPeriodType(1)}>
                        <div className="option-title">Weekly Schedule</div>
                        <div className="option-description">This Blackout Period will reoccur every week on the specific week-days and hours you'll define</div>
                        <div className="field-container day-selection">
                            <div className="from-selection">
                                <div className="label">From: </div>
                                <BigPicker disabled={selectedPeriodType !== 1} value={formValues.fromDay} placeholder="From Week Day" setValue={
                                    (newVal) => onFormUpdate({ ...formValues, fromDay: parseInt(newVal.toString()) })}
                                           options={daysOptions}
                                />
                                <BigPicker disabled={selectedPeriodType !== 1} value={formValues.fromDayTime} placeholder="From Time" setValue={
                                    (newVal) => onFormUpdate({ ...formValues, fromDayTime: parseInt(newVal.toString()) })}
                                           options={timeOptions}
                                />
                            </div>
                            <div className="to-selection">
                                <div className="label">To: </div>
                                <BigPicker disabled={selectedPeriodType !== 1} value={formValues.toDay} placeholder="To Week Day"  setValue={
                                    (newVal) => onFormUpdate({ ...formValues, toDay: parseInt(newVal.toString()) })}
                                           options={daysOptions}
                                />
                                <BigPicker disabled={selectedPeriodType !== 1} value={formValues.toDayTime} placeholder="From Time" setValue={
                                    (newVal) => onFormUpdate({ ...formValues, toDayTime: parseInt(newVal.toString()) })}
                                           options={timeOptions}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`section-option ${selectedPeriodType === 2 ? 'selected' : ''}`} onClick={() => setSelectedPeriodType(2)}>
                        <div className="option-title">Specific Dates</div>
                        <div className="option-description">This Blackout Period will occur once, exactly on the specific DATE you'll select, and won't reoccur</div>
                        <div className="field-container day-selection">
                            <div className="from-selection">
                                <div className="label">From: </div>
                                <BigDatePicker disabled={selectedPeriodType !== 2} value={formValues.fromDate} placeholder="From Date" setValue={
                                    (newVal) => onFormUpdate({ ...formValues, fromDate: newVal })}
                                />
                                <BigPicker disabled={selectedPeriodType !== 2} value={formValues.fromDateTime} placeholder="From Time" setValue={
                                    (newVal) => onFormUpdate({ ...formValues, fromDateTime: parseInt(newVal.toString()) })}
                                           options={timeOptions}
                                />
                            </div>
                            <div className="to-selection">
                                <div className="label">To: </div>
                                <BigDatePicker disabled={selectedPeriodType !== 2} value={formValues.toDate} placeholder="To Date" setValue={
                                    (newVal) => onFormUpdate({ ...formValues, toDate: newVal })}
                                />
                                <BigPicker disabled={selectedPeriodType !== 2} value={formValues.toDateTime} placeholder="From Time" setValue={
                                    (newVal) => onFormUpdate({ ...formValues, toDateTime: parseInt(newVal.toString()) })}
                                           options={timeOptions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="actions">
                <div className="left">
                    {editedBlackoutPeriod?.id ? <Button type="default" size="large" className="danger" onClick={onDelete}>Delete</Button> : null}
                </div>
                <div className="right">
                    <Button type="default" size="large" onClick={onClose}>Cancel</Button>
                    <Button type="primary" size="large" onClick={() => onSubmit(formValues)}>Submit</Button>
                </div>
            </div>
        </div>
    );
}

export default NewBlackoutPeriodForm;